import CanvasChart from './CanvasChart.vue'

export default CanvasChart
